import { render } from "./ClassRegister.vue?vue&type=template&id=4e0dc184"
import script from "./ClassRegister.vue?vue&type=script&lang=js"
export * from "./ClassRegister.vue?vue&type=script&lang=js"

import "./ClassRegister.vue?vue&type=style&index=0&id=4e0dc184&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__